import React from 'react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: "Infrastructure & Automation",
      skills: [
        { name: "Ansible", level: 95 },
        { name: "Terraform", level: 90 },
        { name: "VMware vSphere/ESXi", level: 95 },
        { name: "Linux Administration", level: 98 },
        { name: "Windows Server", level: 92 },
        { name: "Shell Scripting", level: 90 }
      ]
    },
    {
      title: "Enterprise Systems",
      skills: [
        { name: "Active Directory", level: 92 },
        { name: "Office 365", level: 88 },
        { name: "Cisco UCSM", level: 85 },
        { name: "PureStorage", level: 88 },
        { name: "VAST Data", level: 95 },
        { name: "FortiGate Firewalls", level: 85 },
        { name: "VDI Solutions", level: 90 }
      ]
    },
    {
      title: "Development & Cloud",
      skills: [
        { name: "Python", level: 85 },
        { name: "Kubernetes", level: 80 },
        { name: "Docker", level: 82 },
        { name: "Git", level: 85 },
        { name: "CI/CD Pipelines", level: 80 },
        { name: "API Integration", level: 85 }
      ]
    }
  ];

  return (
    <section id="skills" className="section section-alt">
      <div className="container">
        <h2 className="section-title text-center">Skills & Technologies</h2>
        <p className="section-subtitle text-center">
          Enterprise technologies, automation tools, and systems I specialize in
        </p>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div 
                        className="skill-progress"
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;